import clsx from 'clsx'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { LinkNavigationProps } from './ts'

function LinkNavigation({ href, name }: LinkNavigationProps) {
  const { asPath } = useRouter()

  return (
    <Link href={href}>
      <a
        className={clsx('font-medium', {
          'text-violet-150': asPath === href,
        })}
      >
        {name}
      </a>
    </Link>
  )
}

export default LinkNavigation
